import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { checkIsStakeholder } from '../services/adminService';

interface StakeholderRouteProps {
    children: React.ReactNode;
}

const StakeholderRoute: React.FC<StakeholderRouteProps> = ({ children }) => {
    const [isStakeholder, setIsStakeholder] = useState<boolean | null>(null);

    useEffect(() => {
        checkIsStakeholder().then(setIsStakeholder);
    }, []);

    if (isStakeholder === null) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!isStakeholder) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default StakeholderRoute;
